import createCache from '@emotion/cache';

// Matches MUI's recommended cache key and insertion point pattern for Next.js SSR.
export default function createEmotionCache() {
  let insertionPoint;

  if (typeof document !== 'undefined') {
    insertionPoint = document.querySelector(
      'meta[name="emotion-insertion-point"]',
    );
  }

  return createCache({ key: 'mui', insertionPoint });
}
